import {PropsWithChildren, use} from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {translateKey} from "../../utils/fieldsFormatters";
import {LanguageContext} from "../../context/LanguageContext";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {BoxProps} from "@mui/material";

interface BoxAccordionProps extends BoxProps {
    header: string
    tooltipText?: string
    showBorderedCard: boolean
    closedOnInit?: boolean
}

const BoxAccordion = (props: PropsWithChildren<BoxAccordionProps>) => {
    const {header, tooltipText, showBorderedCard, closedOnInit, children} = props
    const className = showBorderedCard ? 'bordered-box-accordion' : 'simple-box-accordion'
    const titleClassName = showBorderedCard ? 'bordered-accordion-header upper-case' : 'filter-type-header'

    const headerId = `${header.replace(' ', '_').toLowerCase()}-header`
    const {language} = use(LanguageContext);


    return <Accordion className={className} disableGutters defaultExpanded={!closedOnInit} id={headerId}>

        <AccordionSummary expandIcon={<ExpandMoreIcon/>}  id={'header-1'}           aria-controls="panel1-content"
>
            <Box className={'accordion-summary-box'}>
                <Typography className={titleClassName}>{translateKey(header, language)} </Typography>
                <Typography  variant={'caption'}  dangerouslySetInnerHTML={{__html:tooltipText as string}}/>
            </Box>
        </AccordionSummary>
        <AccordionDetails >
            {children}

        </AccordionDetails>
    </Accordion>
}

export default BoxAccordion